import { ComponentConfig } from '@measured/puck';

import { Disclaimer } from '../../../../../components/atoms/disclaimer/disclaimer';

type DisclaimerBlockProps = {
  text: string;
  showIcon: boolean;
};

const DisclaimerBlock: ComponentConfig<DisclaimerBlockProps> = {
  label: 'Disclaimer',
  fields: {
    text: {
      contentEditable: true,
      type: 'textarea',
      label: 'Text',
    },
    showIcon: {
      type: 'select',
      label: 'Show Icon',
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
    },
  },
  defaultProps: {
    text: 'This is a disclaimer message',
    showIcon: true,
  },
  render: ({ text, showIcon }: DisclaimerBlockProps) => {
    return <Disclaimer showIcon={showIcon}>{text}</Disclaimer>;
  },
};

export { DisclaimerBlock };
